import { useRef, useState } from "react";
import { fmtTime } from "@/lib/hubs";

export const Waveform = ({ peaks = [], progress = 0, duration = 0, onSeek, comments = [], height = 56, color = "var(--hub)", bars = 120, testId = "waveform" }) => {
  const ref = useRef(null);
  const [hover, setHover] = useState(null);
  const data = resample(peaks, bars);
  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
  };
  return (
    <div
      ref={ref}
      data-testid={testId}
      className="relative w-full cursor-pointer select-none group"
      style={{ height }}
      onMouseMove={(e) => setHover(pos(e))}
      onMouseLeave={() => setHover(null)}
      onClick={(e) => { e.stopPropagation(); onSeek && onSeek(pos(e)); }}
    >
      <div className="absolute inset-0 flex items-center gap-[2px]">
        {data.map((p, i) => {
          const f = i / data.length;
          const played = f < progress;
          const hovered = hover !== null && f < hover && !played;
          return (
            <div key={i} className="flex-1 rounded-full transition-colors duration-150"
              style={{ height: `${Math.max(8, p * 100)}%`, background: played ? color : hovered ? "rgba(255,255,255,0.42)" : "rgba(255,255,255,0.18)" }} />
          );
        })}
      </div>
      {duration > 0 && comments.map((c) => (
        <div key={c.comment_id} title={`${fmtTime(c.at_seconds)} · ${c.user_name}: ${c.text}`}
          className="absolute -bottom-1.5 w-1.5 h-1.5 rounded-full bg-white/80 ring-2 ring-black hover:scale-150 transition-transform"
          style={{ left: `${Math.min(99, (c.at_seconds / duration) * 100)}%` }} />
      ))}
      {hover !== null && duration > 0 && (
        <div className="absolute -top-6 px-1.5 py-0.5 rounded bg-black/90 text-[10px] font-mono text-white pointer-events-none -translate-x-1/2"
          style={{ left: `${hover * 100}%` }}>{fmtTime(hover * duration)}</div>
      )}
    </div>
  );
};

function resample(peaks, n) {
  if (!peaks.length) return Array.from({ length: n }, (_, i) => 0.3 + 0.25 * Math.abs(Math.sin(i / 4)));
  return Array.from({ length: n }, (_, i) => peaks[Math.floor((i / n) * peaks.length)] || 0.2);
}
